module.exports = __webpack_public_path__ + "images/Trash_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Trash_hover.png
// module id = 393
// module chunks = 0 1